import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EcoImg from 'eco-design/base/eco-img';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { langText } from './langText';

const SectionCard: React.FC<{ callbackCart: (item: any) => void }> = ({ callbackCart }) => {
    const { t } = useLang('theProduct.sectionCard');
    const { locale } = useRouter();
    const i18n = langText[locale] || langText['jp'];
    const [list, setList] = useState([]);
    const PRODUCT_CONFIG = {
        jp: {
            item1: { productId: '14692433133935', variantId: '51919145959791' },
            item2: { productId: '14689202667887', variantId: '51927572021615' },
        },
    };

    const getProductConfig = (itemName: any) => PRODUCT_CONFIG[locale]?.[itemName] || PRODUCT_CONFIG.jp[itemName];
    const items = [
        {
            title: t('item1_name'),
            texts: [t('item1_text1'), t('item1_text2')],
            productId: getProductConfig('item1').productId,
            variantId: getProductConfig('item1').variantId,
        },
        {
            title: t('item2_name'),
            texts: [t('item2_text1'), t('item2_text2'), t('item2_text3')],
            productId: getProductConfig('item2').productId,
            variantId: getProductConfig('item2').variantId,
        },
    ];

    const getAsynItem = async (productId: string, variantId: string) => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    return resolve(res.data);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    const addToCart = (info: any) => {
        if ((Number(info?.inventory || 0) > 0 || info?.inventoryPolicy === 'continue') && callbackCart) {
            callbackCart({
                ...info,
            });
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: t('title'),
            product_name: t('title'),
            price: info.discountPrice,
            tag: 'none',
            quantity: 1,
            button_name: t('right_btn') || i18n.link_cart,
            __btn_id1: 'ef-swiper-card-bundle',
            __btn_id2: t('right_btn') || i18n.link_cart,
            __btn_type: 'common',
        });
    };

    useEffect(() => {
        const promises = items?.map((item: any) => getAsynItem(item?.productId, item.variantId));
        Promise.all(promises).then((res) => {
            const old = JSON.parse(JSON.stringify(items));
            const list = res.map((i: any, idx) => {
                if (i.variantImg) {
                    old[idx].img = i.variantImg;
                }
                if (i?.price) {
                    old[idx].discountPrice = i.price;
                }
                if (i?.compareAtPrice ?? i?.price) {
                    old[idx].originalPrice = i?.compareAtPrice ?? i?.price;
                }
                if (i?.inventoryQuantity) {
                    old[idx].inventory = i?.inventoryQuantity || 0;
                }

                old[idx].inventory = i?.inventoryQuantity || 0;
                old[idx].href =
                    idx === 0
                        ? `https://${locale}.ecoflow.com/products/wave-3-portable-air-conditioner?variant=${old[idx].variantId}`
                        : `https://${locale}.ecoflow.com/products/wave-3-wave-3-smart-extra-battery?variant=${old[idx].variantId}`;

                return old[idx];
            });
            setList(list || []);
            console.log('list', list, res);
        });
    }, []);

    return (
        <section
            className={`${css.section} WAVE-Section-Card GtmModuleData-section`}
            id="WAVE-Section-Card"
            data-section-id={'WAVE-Section-Card'}
            data-section-id2={t('title')}
        >

            <ul className="items">
                {list.map((item: any, idx) => (
                    <li className={`item item-${idx + 1}`} key={idx}>
                        <div className="card">
                            <div className="image-col">
                                <div className="image-box" aria-hidden="true">
                                    <EcoImg pc={item.img} />
                                </div>
                            </div>
                            <div className="info-col">
                                <h3 className="title">{item.title}</h3>
                                <ul className="bullets">
                                    {item.texts.map((txt: string, i: number) => (
                                        <li key={i} className="bullet">
                                            <span className="dot" />
                                            <span className="text">{txt}</span>
                                        </li>
                                    ))}
                                </ul>
                                <div className="price-row">
                                    {item.discountPrice && (
                                        <span className="price">
                                            {i18n.price_prefix}
                                            {FormatMoneyLocal(item.discountPrice, locale)}
                                            {i18n.price_suffix}
                                        </span>
                                    )}
                                    {item.originalPrice && item.originalPrice !== item.discountPrice && (
                                        <span className="compare">
                                            {i18n.price_prefix}
                                            {FormatMoneyLocal(item.originalPrice, locale)}
                                            {i18n.price_suffix}
                                        </span>
                                    )}
                                </div>
                                <div className="actions">
                                    <a className="btn btn-primary" href={item?.href} target="_blank" rel="noreferrer">
                                        {t('left_btn')}
                                    </a>
                                    <a className="btn btn-outline" onClick={() => addToCart(item)}>
                                        {t('right_btn')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default SectionCard;
